import { SubscriptionTypes } from "WebSocket/CacheManager/SubscriptionTypes";
import CacheManager from "WebSocket/CacheManager/CacheManager";
import { Store, AnyAction } from "redux"
import * as React from 'react';

interface IState {
    setJwt(jwt: string): any;
    clearJwt(jwt: string): any;
}

interface IProps {
    jwt: string;
    store: Store<any, AnyAction>;
    subscriptionTypes: SubscriptionTypes[];
}

/*
 * Render the Map and its children
 */
export default class CacheManagerDialog extends React.Component<IProps, IState> {

    mgr: CacheManager;

    /**
     * @constructor
     */
    constructor(props: IProps) {
        super(props);
        this.mgr = new CacheManager(props.subscriptionTypes, props.store);
    }

    componentDidUpdate = (prevProps: IProps) => {
        if (prevProps.jwt && !this.props.jwt) {
            this.mgr.clearJwt();
        } else if (!prevProps.jwt && this.props.jwt) {
            this.mgr.onJwtSet();
        }
    }

    componentWillUnmount = () => {
        this.shutdownWebSockets();
    }

    /**
     * Shuts down all web sockets
     */
    shutdownWebSockets = () => {
        if (this.mgr) {
            this.mgr.stopConnection();
        }
    }

    render = () => {
        return (
            <div>
                { this.props.children }
            </div>
        );
    }
}